import { useAuth0 } from '@auth0/auth0-react'

import { setStoredToken } from '~/config'
import { useAppStore } from '~/state/store'
import { theme } from '~/theme'

export function OrgSelect() {
  const me = useAppStore((s) => s.me)
  const selectOrg = useAppStore((s) => s.selectOrg)
  const { logout } = useAuth0()

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        background: theme.bg,
        overflowY: 'auto',
        padding: '24px 16px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420 }}>
        <h2 style={{ margin: '0 0 4px', fontSize: 20, color: theme.cream, fontWeight: 600 }}>
          Choose an organization
        </h2>
        <p style={{ margin: '0 0 18px', fontSize: 13, color: theme.textDim }}>
          {me?.name ? `Signed in as ${me.name}.` : ''} Pick the org to bring to life.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {(me?.organizations ?? []).map((org) => (
            <button
              key={org.id}
              onClick={() => selectOrg(org.id)}
              style={{
                textAlign: 'left',
                padding: '14px 16px',
                background: theme.panel,
                border: `1px solid ${theme.border}`,
                borderRadius: 12,
                color: theme.text,
                cursor: 'pointer',
                fontSize: 15,
              }}
            >
              <div style={{ fontWeight: 600 }}>{org.name}</div>
              <div style={{ fontSize: 12, color: theme.offline, marginTop: 2 }}>
                {org.status ?? ''} · {org.id}
              </div>
            </button>
          ))}
          {(me?.organizations ?? []).length === 0 && (
            <div style={{ color: theme.textDim, fontSize: 14 }}>
              You don&apos;t belong to any organizations.
            </div>
          )}
        </div>
        <button
          onClick={() => {
            setStoredToken('')
            void logout({ logoutParams: { returnTo: window.location.origin } })
          }}
          style={{
            marginTop: 18,
            background: 'none',
            border: 'none',
            color: theme.offline,
            cursor: 'pointer',
            fontSize: 12,
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
